if (customElements && !customElements.get('subscribe-modal')) {
  class SubscribeModal extends HTMLElement {
    constructor() {
      super();
      this.LOCAL_STORAGE_KEY = 'is-show-once-subscribe-modal';
      this.COUNT_SHOW_POPUP_LOCAL_STORAGE_KEY = 'count-show-subscribe-modal';

      this.dataGlobalInfo = {
        delayShow: +this.dataset.delay > 0 ? +this.dataset.delay : 1,
        isShowOnlyOnce: this.dataset.showOnce === 'true',
        messages: {
          empty: this.dataset.errorEmpty || 'Please enter your email',
          invalid: this.dataset.errorInvalid || 'Please enter a valid email',
          duplicate: this.dataset.errorDuplicate || 'This email is already subscribed',
          error: this.dataset.errorGeneral || 'Something went wrong. Please try again',
          success: this.dataset.successMessage || 'Thank you for subscribing!'
        }
      }

      this.triggersCloseModal = this.querySelectorAll('[data-trigger-modal-close]');
      this.isAddModalToDom = false;

      this.nativeSubscribeForm = this.querySelector('[id="contact_form"]');
      this.nativeSuccessMessage = this.nativeSubscribeForm?.querySelector('[data-role="modal-success-message"]');

      this.subscribeForm = this.querySelector('[data-role="subscribe-modal-form"]');
      this.emailInput = this.subscribeForm?.querySelector('input[id="email"]');


      this.init();
    }

    connectedCallback() {
      if (!this.isAddModalToDom) {
        this.remove();
      }
    }

    init() {
      this.bindEvents();

      if (this.statusShowModal) return;

      const delayShow = this.countShowModal === 1 ? 0.1 : this.dataGlobalInfo.delayShow;

      setTimeout(() => {
        this.showModalWindow();
      }, delayShow * 1000);
    }

    get countShowModal() {
      const {isShowOnlyOnce} = this.dataGlobalInfo;

      if (isShowOnlyOnce) {
        return Number(localStorage.getItem(this.COUNT_SHOW_POPUP_LOCAL_STORAGE_KEY))
      } else {
        return Number(sessionStorage.getItem(this.COUNT_SHOW_POPUP_LOCAL_STORAGE_KEY))
      }
    }

    set countShowModal(value) {
      const {isShowOnlyOnce} = this.dataGlobalInfo;

      if (isShowOnlyOnce) {
        localStorage.setItem(this.COUNT_SHOW_POPUP_LOCAL_STORAGE_KEY, value);
      } else {
        sessionStorage.setItem(this.COUNT_SHOW_POPUP_LOCAL_STORAGE_KEY, value);
      }
    }

    get statusShowModal() {
      return localStorage.getItem(this.LOCAL_STORAGE_KEY) === 'true'
    }

    set statusShowModal(value) {
      localStorage.setItem(this.LOCAL_STORAGE_KEY, value);
      return value
    }

    showModalWindow() {
      if (this.countShowModal === 0) {
        this.countShowModal = 1;
      }

      this.isAddModalToDom = true;

      if (!this.isConnected) {
        document.body.append(this);
      }

      setTimeout(() => this.classList.add('is-visible'), 50);
      document.querySelector('html').style.overflowY = 'hidden';
    }

    closeModalWindow() {
      const {isShowOnlyOnce} = this.dataGlobalInfo;

      if(isShowOnlyOnce) {
        this.statusShowModal = true;
      }

      if (this.nativeSubscribeForm && this.nativeSuccessMessage) {
        this.statusShowModal = true;
      }

      if (!this.nativeSubscribeForm) {
        this.statusShowModal = true;
      }

      this.countShowModal += 1;

      this.classList.remove('is-visible');

      setTimeout(() => {
        this.remove();
        this.isAddModalToDom = false;
        document.querySelector('html').style.overflowY = '';
      }, 150);
    }

    validateEmail(email) {
      if (!email || email.trim() === '') {
        return {isValid: false, error: 'empty'};
      }

      const emailRegex = /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailRegex.test(email)) {
        return {isValid: false, error: 'invalid'};
      }

      return {isValid: true, error: null};
    }

    showSuccess() {
      const {messages} = this.dataGlobalInfo;

      const successElem = document.createElement('p');
      successElem.className = 'subscribe-modal-form__success';
      successElem.textContent = messages.success;

      this.subscribeForm.innerHTML = '';
      this.subscribeForm.appendChild(successElem);

      this.animateMessage(successElem)
    }

    showError(errorType) {
      if (!this.emailInput) return;

      this.clearError();
      this.emailInput.classList.add('has-error');
      const {messages} = this.dataGlobalInfo;

      const errorElem = document.createElement('span');
      errorElem.className = 'subscribe-modal-form__error';

      errorElem.textContent = messages[errorType] || messages.error;
      this.emailInput.insertAdjacentElement('afterend', errorElem);

      this.animateMessage(errorElem)
    }

    clearError() {
      this.subscribeForm.querySelector('.subscribe-modal-form__error')?.remove();
    }

    animateMessage(elem) {
      elem.animate([
        {opacity: 0, transform: 'scale(0.8)'},
        {opacity: 1, transform: 'scale(1.2)', offset: 0.6},
        {opacity: 1, transform: 'scale(1)'}
      ], {
        duration: 400,
        easing: 'ease-out',
        fill: 'forwards'
      });
    }

    async sendForm() {
      if (!this.subscribeForm) return;
      const emailValue = this.emailInput?.value || '';
      const validation = this.validateEmail(emailValue);

      if (!validation.isValid) {
        this.showError(validation.error);
        return;
      }

      this.clearError();

      const URL = 'https://shopify-1c-sync-production.up.railway.app/contacts';
      const body = {
        email: emailValue
      }
      const formButtons = this.subscribeForm.querySelectorAll('button');

      try {
        formButtons.forEach(item => item.setAttribute('disabled', ''));

        const response = await fetch(URL, {
          method: "POST",
          body: JSON.stringify(body),
          headers: {
            "Content-Type": "application/json"
          },
        });

        const data = await response.json();

        if (!response.ok) {
          const error = new Error('Request failed');
          error.data = data;
          throw error;
        }

        this.showSuccess();

        setTimeout(this.closeModalWindow.bind(this), 3000);
      } catch (err) {
        if (err.data.error.httpStatus === 409) {
          this.showError('duplicate');
        } else {
          this.showError('error');
        }
        console.error(err);
      } finally {
        formButtons.forEach(item => item.removeAttribute('disabled'));
      }
    }

    async handleSendForm(event) {
      event.preventDefault();
      await this.sendForm();
    }

    handleCloseWindow(event) {
      if (event.target === event.currentTarget) {
        this.closeModalWindow();
      }
    }

    bindEvents() {
      this.triggersCloseModal.forEach(elem => {
        elem.addEventListener('click', this.handleCloseWindow.bind(this));
      });

      if (this.subscribeForm ) {
        this.subscribeForm.addEventListener("submit", this.handleSendForm.bind(this));
      }
    }
  }

  customElements.define('subscribe-modal', SubscribeModal);
}